module.exports = "<action-items show-filters=\"false\" show-refresh-button=\"false\" show-see-all=\"true\" show-completed-today=\"true\"\n              max-action-items=\"5\" source=\"summaryView\"></action-items>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboardToDoList.html
// module id = 227
// module chunks = 1